// The root: the language (the staff member's, pt-BR before sign-in, D61) and the theme.

import { applyTheme, readTheme } from '@apsio/ui'
import { useQuery } from '@tanstack/react-query'
import { Outlet } from '@tanstack/react-router'
import { useEffect } from 'react'
import { meQuery } from '../api/queries'
import { DEFAULT_LOCALE, I18nProvider, isLocale, type Locale } from '../i18n'

export function RootLayout() {
  const me = useQuery({ ...meQuery, throwOnError: false })
  const locale: Locale = isLocale(me.data?.locale) ? me.data.locale : DEFAULT_LOCALE
  useEffect(() => {
    document.documentElement.lang = locale
  }, [locale])
  useEffect(() => applyTheme(readTheme()), [])
  return (
    <I18nProvider locale={locale}>
      <Outlet />
    </I18nProvider>
  )
}
